import { render, staticRenderFns } from "./portfolioB.vue?vue&type=template&id=49035434"
import script from "./portfolioB.vue?vue&type=script&lang=js"
export * from "./portfolioB.vue?vue&type=script&lang=js"
import style0 from "./portfolioB.vue?vue&type=style&index=0&id=49035434&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports